(function ($) {
  $.fn.wsModal = function (options, attr) {
    if (typeof options != 'undefined' && options.constructor === String) {
      switch (options) {
        case 'resize':
          return this.each(function () {
            this.resizeModal();
          });
        case 'open':
          return this.each(function () {
            this.openModal();
          });
        case 'close':
          return this.each(function () {
            this.closeModal();
          });
        case 'setLoading':
          return this.each(function () {
            this.setLoading(attr);
          });
        default:
          throw 'Option does not exist: ' + options;
      }
    }

    return this.each(function () {
      /*var opt = $.extend({
        delay: 100,
        speed: 10,
      }, options);*/

      let modalContentElement = $(this);  // Element with content to show in modal

      if (modalContentElement.data('ws-modal')) {
        console.warn('Trying to reinitialize the modal for element. Skipping.', modalContentElement);
        return;
      }
      modalContentElement.data('ws-modal', this);

      // Elements
      let modalContentContainerElement;
      let modalItemStorage;
      let modalContainerElement;
      let modalElement;
      let modalCloseElement;
      let modalLoadingIndicator;

      // Variables
      //let hover = false;

      let bindEvents = function () {
        modalContainerElement.click(function ( event ) {
          if (event.target !== modalContainerElement.get(0)) {
            return;
          }

          closeModal();
        });
        modalCloseElement.click(closeModal);
      }

      // Resize.
      let resizeModal = this.resizeModal = function () {

      }

      //let openModal = this.openModal = function () {
      this.openModal = function () {
        if (modalContainerElement.is(':visible')) {
          console.warn('Open modal: modal already open!');
          return;
        } else {
          console.log('Open modal');
        }

        let parent = $('body');

        modalContentContainerElement.append(modalContentElement);

        parent.append(modalContainerElement);

        modalContainerElement.fadeIn({
          complete: function () {
            modalContentElement.trigger('ws-modal:opened');
          },
        });

        parent.addClass('ws-modal-open');
      }

      let closeModal = this.closeModal = function () {
        if (modalContainerElement.is(':visible')) {
          console.log('Close modal');
        } else {
          console.warn('Close modal: modal already closed!');
          return;
        }
        //let parent = $('body');

        modalContainerElement.fadeOut({ complete: function () {
          modalContentElement.appendTo(modalItemStorage);
          modalContainerElement.detach();
          if ($('.ws-modal-container:visible').length === 0) {
            // No more open modals, we can scroll again.
            $('body').removeClass('ws-modal-open');
          }
        }});
      }

      //let setLoading = this.setLoading = function (isLoading) {
      this.setLoading = function (isLoading) {
        console.log('Set loading status to', isLoading);
        if (isLoading) {
          modalLoadingIndicator.show();
          modalContentContainerElement.css('opacity', 0);
        } else {
          modalLoadingIndicator.hide();
          modalContentContainerElement.css('opacity', 1);
        }
      }

      let initialize = function () {
        modalItemStorage = $('#ws-modal-item-storage');

        //modalElement = $('<div class="ws-modal">');
        modalContainerElement = $('<div class="ws-modal-container">');
        modalContainerElement.addClass(modalContentElement.attr('id'));

        modalElement = $('#ws-modal-template').children().first().clone(); // Clone template

        modalContainerElement.append(modalElement);
        modalContentContainerElement = modalElement.find('.ws-modal-content');
        modalCloseElement = modalElement.find('.ws-modal-close');
        modalLoadingIndicator = modalElement.find('.ws-modal-loading-indicator');

        resizeModal();
        bindEvents();
      };

      initialize();

      $(window).load(function () {
        resizeModal();
      });
      $(window).resize(function () {
        resizeModal();
      });
    });
  };
})(jQuery);
